var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"91vh"},on:{"click":_vm.goback}},[_c('error-content',{attrs:{"code":"404","desc":"~~点击返回~","src":_vm.src}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }